import HeroSection from './components/HeroSection';
import ContactInfoSection from './components/ContactInfoSection';
import FormSection from './components/FormSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Contact() {
  return (
    <>
      <HeroSection />
      <ContactInfoSection />
      <FormSection />
      <TestimonialSection />
      <CTASection />
    </>
  );
}